export const getContext = (width: number, height: number) => {
    const canvas = document.createElement('canvas');
    canvas.setAttribute('width', width.toString());
    canvas.setAttribute('height', height.toString());
    return canvas.getContext('2d');
};

export const getImageData = (target: string | HTMLImageElement, scale: number = 0.5): Promise<Uint8ClampedArray> => {
    const targetIsUrl = typeof target === 'string';
    const img = targetIsUrl ? new Image() : (target as HTMLImageElement);

    if (targetIsUrl && !/^data/.test(target as string)) {
        img.crossOrigin = 'Anonymous';
    }

    return new Promise((resolve, reject) => {
        const work = () => {
            const width = img.width * scale;
            const height = img.height * scale;
            const context = getContext(width, height);
            context!.drawImage(img, 0, 0, width, height);
            const { data } = context!.getImageData(0, 0, width, height);
            resolve(data);
        };
        if (targetIsUrl) {
            img.onload = work;
            const errorHandler = (err: any) => reject(err);

            img.onerror = errorHandler;
            img.onabort = errorHandler;
            img.src = target as string;
        } else {
            work();
        }
    });
};

interface IColor {
    color: string;
    count: number;
}
export type IgnoreFnc = (rgb: number[]) => boolean;

export const getCounts = (data: Uint8ClampedArray, ignore: string[] | IgnoreFnc): IColor[] => {
    const countMap: { [key: string]: { color: string; count: number } } = {};

    for (let i = 0; i < data.length; i += 4) {
        const alpha: number = data[i + 3];
        if (alpha === 0) {
            continue;
        }

        const rgbComponents = Array.from(data.subarray(i, i + 3));
        const color: string =
            alpha && alpha !== 255 ? `rgba(${[...rgbComponents, alpha].join(',')})` : `rgb(${rgbComponents.join(',')})`;

        if (Array.isArray(ignore) && ignore.indexOf(color) !== -1) {
            continue;
        } else if (typeof ignore === 'function' && (ignore as IgnoreFnc)(rgbComponents)) {
            continue;
        }

        if (countMap[color]) {
            countMap[color].count++;
        } else {
            countMap[color] = { color, count: 1 };
        }
    }

    const counts: IColor[] = [];
    for (const key in countMap) {
        if (Object.prototype.hasOwnProperty.call(countMap, key)) {
            counts.push(countMap[key]);
        }
    }
    return counts.sort((a: IColor, b: IColor) => b.count - a.count);
};
